module.exports = __webpack_public_path__ + "static/media/save.9d3ef333.svg";